import React, { FC } from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import FullscreenDialogClose from '../../../FullscreenDialog/components/Close/Close';
import BackwardButton from '../../Button/components/BackwardButton/BackwardButton';
import { useIsMobile } from '../../../utils';

interface ClassNameMap {
	inner?: string;
	leftSlot?: string;
	centerSlot?: string;
	rightSlot?: string;
	closeWrapper?: string;
	closeText?: string;
}

export type HeaderProps = {
	className?: string;
	classes?: ClassNameMap;
	left?: React.ReactNode;
	center?: React.ReactNode;
	right?: React.ReactNode;
	equalSlotsBasis?: boolean;
	showEmptySlots?: boolean;
	onClose?: React.DispatchWithoutAction;
	onGoBackward?: React.DispatchWithoutAction;
};

const Header: FC<HeaderProps> = ({
	className,
	classes,
	left,
	center,
	right,
	equalSlotsBasis = true,
	showEmptySlots = true,
	onClose,
	onGoBackward
}) => {
	const theme = useTheme('BaseComponents').Header;
	const isMobile = useIsMobile();

	return (
		<div className={cn(theme.wrapper, className)}>
			<div className={cn(theme.inner, classes?.inner)}>
				{onGoBackward && isMobile && <BackwardButton className={theme.backwardButton} onClick={onGoBackward} />}
				{(showEmptySlots || left) && (
					<div
						className={cn(theme.leftSlot, classes?.leftSlot, {
							[theme.equalSlotsBasis]: equalSlotsBasis
						})}
					>
						{left}
					</div>
				)}

				{(showEmptySlots || center) && (
					<div
						className={cn(theme.centerSlot, classes?.centerSlot, {
							[theme.equalSlotsBasis]: equalSlotsBasis
						})}
					>
						{center}
					</div>
				)}

				{(showEmptySlots || right) && (
					<div
						className={cn(theme.rightSlot, classes?.rightSlot, {
							[theme.equalSlotsBasis]: equalSlotsBasis
						})}
					>
						{right}
					</div>
				)}
				{onClose && (
					<FullscreenDialogClose
						closeClassName={cn(theme.closeWrapper, classes?.closeWrapper)}
						textClassName={cn(theme.closeText, classes?.closeText)}
						onClose={onClose}
					/>
				)}
			</div>
		</div>
	);
};

export default Header;
